import React from 'react'
import { useSelector } from 'react-redux'
import { useStyles } from './style'
import { buildToolkitUrl } from '../../../helpers/toolkit'
import { Typography, Dialog, DialogTitle, DialogContent, Grid, IconButton, DialogActions, Button, Box, Tooltip } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import { AppSlice } from '../../../reducers'
import { CONSTANTS } from '../../../util/constants'

const SkillBitePreviewModal = ({ skillBite, open, setOpen }) => {
  const { name, id, sessions } = skillBite
  const classes = useStyles()
  const envInfo = useSelector(AppSlice.selectors.selectEnvInfo)
  const baseToolkitUrl = buildToolkitUrl(CONSTANTS.SB_PREVIEW_TENANT_KEY(envInfo.stage), envInfo.stage, envInfo.tld)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      data-test='skill-bite-preview-modal'
      PaperProps={{
        sx: {
          width: '50%'
        }
      }}
    >
      <DialogTitle
        data-test='skill-bite-preview-modal-title'
        style={{ borderBottom: '1px solid #E0E0E0' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant='h6'
            data-test='skill-bite-preview-modal-title'
          >
            {name}
          </Typography>
          <Tooltip placement='top' title='Landing Page Preview'>
            <IconButton
              onClick={() => window.open(`${baseToolkitUrl}/skill-bites/${id}?preview=true`, '_blank')}
              data-test='skill-bite-preview-modal-title-preview-button'
            >
              <LaunchIcon color='primary' />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogTitle>
      <Grid
        container
        direction='column'
      >
        <DialogContent
          data-test='skill-bite-preview-modal-list'
        >
          {sessions.map((session, key) => (
            <Grid
              container
              key={key}
              className={classes.listItem}
              direction='row'
              alignItems='center'
              data-test={`skill-bite-preview-modal-list-item-${key}`}
            >
              <Grid item md={11}>
                <Typography
                  variant='body2'
                  data-test={`skill-bite-preview-modal-list-item-${key}-title`}
                >
                  {session.name}
                </Typography>
              </Grid>
              <Grid item md={1}>
                <Tooltip placement='top' title='Session Preview'>
                  <IconButton
                    onClick={() => window.open(`${baseToolkitUrl}/skill-bites/${id}/${session.id}?preview=true`, '_blank')}
                    data-test={`skill-bite-preview-modal-list-item-${key}-preview-button`}
                  >
                    <LaunchIcon color='primary' />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          ))}
        </DialogContent>
      </Grid>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          data-test='skill-bite-preview-modal-close-button'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SkillBitePreviewModal
